import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, FormControl, FormHelperText, Grid, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { useStore } from 'src/stores';
import { newTeamMemberSchema } from 'src/utils/formValidation/NewTeamMember';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
export const EditAdminAccountModalContent = observer(_ref => {
  var _formik$values, _formik$values2;
  let handleModalClose = _ref.handleModalClose,
    data = _ref.data,
    isLoading = _ref.isLoading,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  let adminAccountInitialValues = _objectSpread(_objectSpread({}, data), {}, {
    email: (data === null || data === void 0 ? void 0 : data.email) || (data === null || data === void 0 ? void 0 : data.newEmail),
    phone: data.phone ? data.phone.replace('+1', '').replace('+38', '') : ''
  });
  const updateAdminAccount = async params => {
    const resp = await store.admin.updateAdminAccountAsync.run(beforeSubmitDataValidation(params));
    return resp;
  };
  const formik = useFormik({
    initialValues: adminAccountInitialValues,
    validationSchema: newTeamMemberSchema,
    onSubmit: async values => {
      toast('loading', {
        body: ['Saving...']
      }); // ? i18n

      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const changesToPut = {};
      const formFields = Object.keys(values);
      if (formFields.some(k => values[k] !== adminAccountInitialValues[k])) {
        const changedValues = formFields.filter(k => values[k] !== adminAccountInitialValues[k]);
        const firstOrLastNameChanged = changedValues.filter(k => ['firstName', 'lastName'].includes(k));
        if (firstOrLastNameChanged.length) {
          ['firstName', 'lastName'].map(k => {
            changesToPut[k] = values[k];
            return undefined;
          });
        }
        const phoneOrEmailChanged = changedValues.filter(k => ['email', 'phone'].includes(k));
        if (phoneOrEmailChanged.length) {
          phoneOrEmailChanged.map(k => {
            changesToPut[k] = k.toLowerCase() === 'phone'.toLowerCase() ? "".concat(phoneCode).concat(values[k].toString().replace(/[^0-9+]/g, '')) : values[k];
            return undefined;
          });
        }
      }
      if (!Object.keys(changesToPut).length) return;
      const updateAdminResp = await updateAdminAccount(_objectSpread(_objectSpread({}, changesToPut), {}, {
        accountId: data.id
      }));
      if (updateAdminResp && updateAdminResp.isSuccessful) {
        adminAccountInitialValues = _objectSpread({}, values);
        toast('success', {
          body: [t('general.successfully_updated')]
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        triggerRefresh && triggerRefresh();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        handleModalClose && handleModalClose();
      }
      return;
    }
  });
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.personal_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    label: t('general.last_name'),
    variant: "outlined",
    value: (_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    error: formik.touched.email && Boolean(formik.errors.email),
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "email"
  }, t('general.email_address')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "email",
    type: "email",
    label: t('general.email_address'),
    value: formik.values.email
  }), formik.touched.email && !!formik.errors.email && /*#__PURE__*/React.createElement(FormHelperText, null, translate(formik.errors.email, t)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '13-edit-admin-account-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    disabled: !formik.isValid || !Object.keys(formik.touched).length,
    'custom-attribute': '14-edit-admin-account-modal'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.admin.updateAdminAccountAsync.inProgress
  }));
});